import { profile, axiosConfig } from 'api';

import { Response } from 'models/response';

export interface CreateOnboarding {
  groupType: string;
  groupName: string;
  ruleName: string;
  onboardingUsers: OnboardingUser[];
}

export interface OnboardingUser {
  email: string;
  name: string;
  lastName: string;
  groupName: string;
  approver: boolean;
  sequence: number;
}

export interface IsCreated {
  created: boolean;
}

export const createOnboarding = (onboarding: CreateOnboarding): Promise<Response<IsCreated>> =>
  profile.post<Response<IsCreated>>('onboarding', onboarding, axiosConfig).then((response) => response.data);
